import czorsztynImage from "./images/czorsztynianka-czorsztyn.png";
import niedzicaImage from "./images/czorsztynianka-niedzica.png";
import ericaImage from "./images/apartment-erica.png"
import ericaDeluxeImage from "./images/apartment-erica-deluxe.png";

export const virtualTourData = [
    {
        id: 1,
        title: "Czorsztynianka Marina - Czorsztyn",
        description: "Virtual tour of the gondola station in Czorsztyn",
        href: "https://tour.panoee.net/czorsztynianka-przystan-w-czorsztynie/68f69c7cd87e79ace11b41d4",
        image: {
            src: czorsztynImage,
            alt: "Czorsztynianka Marina in Czorsztyn",
        },
    },
        {
        id: 2,
        title: "Czorsztynianka Marina - Niedzica",
        description: "Virtual tour of the gondola station in Niedzica",
        href: "https://tour.panoee.net/czorsztynianka-przystan-w-niedzicy/68ff4af382d350983307778d",
        image: {
            src: niedzicaImage,
            alt: "Czorsztynianka Marina in Niedzica",
        },
    },
        {
        id: 3,
        title: "Erica Apartment in Zakopane",
        description: "Virtual tour of the Erica apartment in Zakopane",
        href: "https://tour.panoee.net/6904a27a8eb46a7072e7d4c5/6904a4578eb46a0ac6e7d4ea",
        image: {
            src: ericaImage,
            alt: "Erica Apartment in Zakopane",
        },
    },
        {
        id: 4,
        title: "Erica Deluxe Apartment in Zakopane",
        description: "Virtual tour of the Erica Deluxe apartment in Zakopane",
        href: "https://tour.panoee.net/69089476886027254905d2f9/6908bd6488602708a305d6a4",
        image: {
            src: ericaDeluxeImage,
            alt: "Erica Deluxe Apartment in Zakopane",
        },
    },
];